import { computed, type ComputedRef } from 'vue';

import {
  getCriteriaOptions,
  getOptionalCriteria,
  getStrongCriteria,
} from '@/composables/helpee-signup/useHelpeeCriteria';
import type { useAuthStore } from '@/stores/auth';

type AuthStore = ReturnType<typeof useAuthStore>;

export function useHelpeeSignupViewModel(params: {
  authStore: AuthStore;
  isIntro: ComputedRef<boolean>;
}) {
  const isInFlow = computed(() => !params.isIntro.value);

  const backgroundClass = computed(() => {
    if (
      params.authStore.helpeeSignUpData?.headerType === 'community' &&
      params.isIntro.value
    ) {
      return 'gradient__community';
    }

    return 'bg-background-default';
  });

  const campaignCriteria = computed(
    () => params.authStore.helpeePostSignUpData?.criteria || []
  );

  const strongCriteria = computed(() =>
    getStrongCriteria(campaignCriteria.value)
  );

  const optionalCriteria = computed(() =>
    getOptionalCriteria(campaignCriteria.value, strongCriteria.value)
  );

  const strongCriteriaOptions = computed(() =>
    getCriteriaOptions(strongCriteria.value)
  );

  return {
    isInFlow,
    backgroundClass,
    campaignCriteria,
    strongCriteria,
    optionalCriteria,
    strongCriteriaOptions,
  };
}
